import * as React from 'react';
import classNames from 'classnames';
import { CnModal } from '@/components/cn-modal';
import { CnIcon } from '@/components/cn-icon';
import isFunction from 'lodash/isFunction';
export const CnPopup = (props) => {
    const { prefix = 'cn-ui-m-', closeIconType = 'icon-error', bgColor = 'transparent', visible, children, closeMode = ['mask', 'close'], className, style, onClose, ...others } = props;
    const clsPrefix = `${prefix}dialog-popup`;
    const containerStyle = style || {};
    if (bgColor) {
        containerStyle.backgroundColor = bgColor;
    }
    // 关闭事件
    const handleClose = (reason) => {
        if (isFunction(onClose) &&
            Array.isArray(closeMode) &&
            closeMode.indexOf(reason) > -1) {
            onClose(reason);
        }
    };
    return (React.createElement(CnModal, { ...others, visible: visible, containerClassName: clsPrefix, onClose: handleClose },
        React.createElement("div", { className: classNames(className, `${clsPrefix}-container`), style: containerStyle }, children),
        closeMode?.includes('close') && (React.createElement(CnIcon, { className: `${clsPrefix}-popup-close`, type: closeIconType, size: "l", onClick: () => handleClose('close') }))));
};
